import React, { useState } from "react";
import 'bootstrap-icons/font/bootstrap-icons.css';
import * as bootstrap from 'bootstrap'
import './ContentClubCuidatiaV2.css'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { UsuarioContext } from '../../contexts/UsuarioContext';
import { useSessionStore } from "../../hooks/useSessionStore";
import { Stripe } from 'stripe';
import getPublishableKey from '../../stripe/publishableKey';
import { loadStripe } from "@stripe/stripe-js";



const stripe_publishable_key = getPublishableKey()
// const stripe_secret_key = getSecretKey()
const stripePromise = loadStripe(stripe_publishable_key)
// const stripe = Stripe(stripe_secret_key)


export const ContentClubCuidatiaV2 = () => {
    const navigate = useNavigate()
    const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

    const handleSubscription = async (price, planName) => {
        if (isLoading) return

        isLoading = true

        // Show loading state
        const button = document.querySelector(".btn-pago")
        const originalText = button.innerHTML
        button.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Redirigiendo...'
        button.disabled = true

        // Simulate purchase process
        setTimeout(() => {

            // Reset button
            button.innerHTML = originalText
            button.disabled = false
            isLoading = false

        }, 2000)
        
        let data = {
            'plan': planName,
            'price': price
        }
        try{
            const response = await axios({
                method: 'post',
                url: window.ipdirection + 'create-subscription-session/',
                headers: {
                    Authorization: 'Bearer ' + Usuario.access,
                },
                data: data,
            })

            if (response.data.error) {
                console.error("Error al crear la sesión de Stripe:", response.data.error);
                return;
            }

            const sessionId  = response.data.sessionId;
            const stripe = await stripePromise;
            await stripe.redirectToCheckout({ sessionId });

        } catch (error) {
            console.error("Error en la suscripción:", error);
        }
    }

    // Membership Plans Data
    const membershipPlans = {
    basic: {
        id: "basico",
        name: "Básico",
        price: 150,
        period: "año",
        description: "Perfecto para comenzar",
        popular: false,
    },
    premium: {
        id: "premium",
        name: "Premium",
        price: 950,
        period: "año",
        description: "La opción más popular para resultados serios",
        popular: true,
    },
    todo: {
        id: "todo",
        name: "Todo incluido",
        price: 2000,
        period: "año",
        description: "La experiencia definitiva para empresas",
        popular: false,
    },
    }

    // Global Variables
    let selectedPlan = "premium"
    let isLoading = false

    // DOM Content Loaded
    document.addEventListener("DOMContentLoaded", () => {
    initializePage()
    setupEventListeners()
    setupAnimations()
    })

    // Initialize Page
    function initializePage() {
    console.log("Página de membresías inicializada")

    // Set initial selected plan
    selectPlan(selectedPlan)

    // Setup collapse event listeners
    setupCollapseListeners()

    // Initialize tooltips if needed
    initializeTooltips()
    }

    // Setup Event Listeners
    function setupEventListeners() {
    // Card click listeners
    const membershipCards = document.querySelectorAll(".membership-card")
    membershipCards.forEach((card) => {
        card.addEventListener("click", function (e) {
        // Don't trigger if clicking on collapse buttons or CTA buttons
        if (e.target.closest(".btn") && !e.target.closest(".cta-button")) {
            return
        }

        const planId = this.getAttribute("data-plan")
        selectPlan(planId)
        })
    })

    // Scroll animations
    window.addEventListener("scroll", handleScroll)

    // Resize handler
    window.addEventListener("resize", handleResize)
    }

    // Setup Collapse Listeners
    function setupCollapseListeners() {
    const collapseButtons = document.querySelectorAll('[data-bs-toggle="collapse"]')

    collapseButtons.forEach((button) => {
        button.addEventListener("click", function (e) {
        e.stopPropagation() // Prevent card selection

        const icon = this.querySelector("transition-icon")
        const target = document.querySelector(this.getAttribute("data-bs-target"))

        // Toggle icon rotation
        setTimeout(() => {
            if (target.classList.contains("show")) {
            icon.style.transform = "rotate(90deg)"
            } else {
            icon.style.transform = "rotate(0deg)"
            }
        }, 1)
        })
    })
    }

    // Select Plan Function
    function selectPlan(planId) {
    selectedPlan = planId

    // Remove selected class from all cards
    const allCards = document.querySelectorAll(".membership-card")
    allCards.forEach((card) => {
        card.classList.remove("selected")
    })

    // Add selected class to chosen card
    const selectedCard = document.querySelector(`[data-plan="${planId}"]`)
    if (selectedCard) {
        selectedCard.classList.add("selected")
    }

    // Track selection
    trackEvent("plan_selected", { plan: planId })

    console.log(`Plan seleccionado: ${planId}`)
    }

    // Handle Purchase
    function handlePurchase(planId) {
    if (isLoading) return

    isLoading = true
    const plan = membershipPlans[planId]

    if (!plan) {
        console.error("Plan no encontrado:", planId)
        isLoading = false
        return
    }

    // Show loading state
    const button = document.querySelector(`[data-plan="${planId}"] .cta-button`)
    const originalText = button.innerHTML
    button.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Procesando...'
    button.disabled = true

    // Simulate purchase process
    setTimeout(() => {

        // Show success message
        showPurchaseModal(plan)

        // Reset button
        button.innerHTML = originalText
        button.disabled = false
        isLoading = false

    }, 2000)
    }

    // Show Purchase Modal
    function showPurchaseModal(plan) {
    const modalHtml = `
        <div class="modal fade" id="purchaseModal" tabindex="-1" aria-labelledby="purchaseModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0">
                    <div class="modal-header border-bottom border-secondary">
                        <h5 class="modal-title gradient-text" id="purchaseModalLabel">
                            <i class="bi bi-check-circle-fill text-success me-2"></i>
                            ¡Excelente elección!
                        </h5>
                        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center py-4">
                        <div class="mb-4">
                            <div class="popular-badge mb-2 mx-auto">
                                <p class="badge text-white px-4 py-2 bg-gradient-${plan.id === "basico" ? "blue" : plan.id === "premium" ? "purple" : "yellow"}">
                                    Más ${plan.id === "basico" ? "Comprado" : plan.id === "premium" ? "Popular" : "Valorado"}
                                </p>
                            </div>
                            <h4 class="mb-2">Plan ${plan.name}</h4>
                            <p class="text-dark-emphasis">${plan.description}</p>
                            <div class="display-6 fw-bold gradient-text">€${plan.price}/${plan.period}</div>
                        </div>
                        <p class="text-dark-emphasis mb-4">
                            Serás redirigido a nuestro sistema de pagos seguro para completar tu suscripción.
                        </p>
                        <div class="d-grid gap-2">
                            <button id="subscribe-btn" type="button" class="btn-pago btn btn-primary w-100 cta-button basic-cta">
                                <i class="bi bi-credit-card me-2"></i>
                                Proceder al Pago
                            </button>
                            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;

    // Elimina el modal si ya existe
    const existingModal = document.getElementById("purchaseModal");
    if (existingModal) {
        existingModal.remove();
    }

    // Añade el nuevo modal al body
    document.body.insertAdjacentHTML("beforeend", modalHtml);

    // Muestra el modal
    const modal = new bootstrap.Modal(document.getElementById("purchaseModal"));
    modal.show();

    // Añade el event listener al botón
    document.getElementById("subscribe-btn").addEventListener("click", function () {
        handleSubscription(plan.price, plan.name);
    });
    }

    // Setup Animations
    function setupAnimations() {
    // Intersection Observer for scroll animations
    const observerOptions = {
        threshold: 0.1,
        rootMargin: "0px 0px -50px 0px",
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.style.opacity = "1"
            entry.target.style.transform = "translateY(0)"
        }
        })
    }, observerOptions)

    // Observe membership cards
    const cards = document.querySelectorAll(".membership-card")
    cards.forEach((card, index) => {
        card.style.opacity = "0"
        card.style.transform = "translateY(30px)"
        card.style.transition = `opacity 0.6s ease ${index * 0.2}s, transform 0.6s ease ${index * 0.2}s`
        observer.observe(card)
    })
    }

    // Handle Scroll
    function handleScroll() {
    const scrolled = window.pageYOffset
    const parallax = document.querySelector(".floating-element-1")
    const parallax2 = document.querySelector(".floating-element-2")

    if (parallax) {
        parallax.style.transform = `translateY(${scrolled * 0.5}px)`
    }

    if (parallax2) {
        parallax2.style.transform = `translateY(${scrolled * -0.3}px)`
    }
    }

    // Handle Resize
    function handleResize() {
    // Adjust floating elements on resize
    const elements = document.querySelectorAll(".floating-element")
    elements.forEach((element) => {
        // Recalculate positions if needed
    })
    }

    // Initialize Tooltips
    function initializeTooltips() {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl))
    }

    function trackEvent(eventName, properties = {}) {
    // Analytics tracking
    console.log("Event tracked:", eventName, properties)
    }

    return (
    <>
    <body>
    <div className="background-container">
        <div className="floating-element floating-element-1"></div>
        <div className="floating-element floating-element-2"></div>
        <div className="gradient-overlay"></div>
    </div>

    <div className="main-content">
        <div className="container-fluid px-4 py-5">
            <div className="text-center mb-5">
                <h1 className="display-1 fw-bold gradient-text mb-4">
                    Elige Tu Plan
                </h1>

                <p className="lead text-dark-emphasis mx-auto" style={{maxWidth: "600px"}}>
                    Descubre la membresía perfecta para alcanzar tus objetivos. Cada plan está diseñado para llevarte al siguiente nivel.
                </p>

                <div className="d-inline-flex align-items-center gap-2 glass-badge rounded-pill px-4 py-2 mb-4">
                    <i className="bi bi-stars text-warning"></i>
                    <span className="text-dark small fw-medium">Estos son las planes que ofrecemos</span>
                </div>
            </div>

            <div className="row g-3 justify-content-center" style={{maxWidth: "1400px", margin: "0 auto"}}>
                <div className="col-lg-4 col-md-6">
                    <div className="card membership-card h-100" data-plan="basic">
                        <div className="card-gradient basic-gradient"></div>
                        <div className="glass-effect"></div>
                        
                        <div className="card-header text-center border-0 bg-transparent position-relative">
                            {/* <div className="plan-icon basic-icon mx-auto mb-3">
                                <i className="bi bi-3-circle-fill"></i>
                            </div> */}
                            <div className="popular-badge mb-3 mx-auto">
                                <span className="badge bg-gradient-blue text-white px-4 py-2">Más Comprado</span>
                            </div>
                            <h3 className="card-title text-dark mb-2">Plan Básico</h3>
                            <p className="text-dark-emphasis small mb-3">Perfecto para comenzar</p>
                            {/* <div class="d-flex align-items-center justify-content-center position-relative">
                                <div class="d-flex flex-column">
                                    <span class="badge bg-danger align-self-start mb-1">-20%</span>
                                    <span class="text-danger text-decoration-line-through me-3" style={{fontSize: "1.2rem;"}}>200€</span>
                                </div>
                                <div class="d-flex align-items-baseline">
                                    <span class="display-4 fw-bold text-dark">150€</span>
                                    <span class="text-dark-emphasis">/año</span>
                                </div>
                            </div> */}
                            <div class="d-flex align-items-baseline justify-content-center">
                                <span class="display-4 fw-bold text-dark">150€</span>
                                <span class="text-dark-emphasis">/año</span>
                            </div>
                        </div>

                        <div className="card-body position-relative">
                            <div className="feature-category mb-3">
                                <button className="btn btn-link text-start w-100 p-0 text-dark fw-semibold small d-flex align-items-center justify-content-between" 
                                        onClick={()=>{setupCollapseListeners()}} data-bs-toggle="collapse" data-bs-target="#access">
                                    Acceso y Visibilidad
                                <i className="bi bi-chevron-right transition-icon"></i>  
                                </button>
                                <div className="collapse" id="access">
                                    <div className="mt-2">
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">2 Publicaciones de servicios</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Perfil básico (datos limitados)</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Visibilidad mínima en búsquedas</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Video presentación comunidad Cuidatia</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Verificación VIP</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Historia de vida de usuarios</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="feature-category mb-3">
                                <button className="btn btn-link text-start w-100 p-0 text-dark fw-semibold small d-flex align-items-center justify-content-between" 
                                        onClick={()=>{setupCollapseListeners()}} data-bs-toggle="collapse" data-bs-target="#marketing">
                                    Marketing y Promoción
                                    <i class="bi bi-chevron-right transition-icon"></i>
                                </button>
                                <div className="collapse" id="marketing">
                                    <div className="mt-2">
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Bienvenida RRSS y Newsletter</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Acceso a campañas promocionales</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Patrocinio Webinar</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Herramientas de marketing</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Rendimiento de campañas personalizado</span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="feature-category mb-3">
                                <button className="btn btn-link text-start w-100 p-0 text-dark fw-semibold small d-flex align-items-center justify-content-between" 
                                        onClick={()=>{setupCollapseListeners()}} data-bs-toggle="collapse" data-bs-target="#support">
                                    Gestión y Soporte Profesional
                                    <i class="bi bi-chevron-right transition-icon"></i>
                                </button>
                                <div className="collapse" id="support">
                                    <div className="mt-2">
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Soporte estándar (correo o FAQ)</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Análisis básico (vistas por servicio)</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Gestión de usuarios</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Tarjeta digital y Agenda digital</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Facturación electrónica</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-category mb-4">
                                <button className="btn btn-link text-start w-100 p-0 text-dark fw-semibold small d-flex align-items-center justify-content-between" 
                                        onClick={()=>{setupCollapseListeners()}} data-bs-toggle="collapse" data-bs-target="#recursos">
                                    Desarrollo y Recursos Exclusivos
                                    <i class="bi bi-chevron-right transition-icon"></i>
                                </button>
                                <div className="collapse" id="recursos">
                                    <div className="mt-2">
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Eventos presenciales sin descuento</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Formación digital</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Aplicaciones para usuarios Físico/Cognitivo</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Creación libros digitales/físicos con X% descuento</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button className="btn btn-primary w-100 cta-button basic-cta" onClick={()=>{handlePurchase('basic')}}>
                                <span>Comenzar Ahora</span>
                                <i class="bi bi-arrow-right transition-icon ms-2"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4 col-md-6">
                    <div className="card membership-card h-100 popular-plan" data-plan="premium">
                        <div className="card-gradient premium-gradient"></div>
                        <div className="glass-effect"></div>
                        
                        <div className="card-header text-center border-0 bg-transparent position-relative">
                            {/* <div className="plan-icon premium-icon mx-auto mb-3">
                                <i className="bi bi-1-circle-fill"></i>
                            </div> */}
                            <div className="popular-badge mb-3 mx-auto">
                                <span className="badge bg-gradient-purple text-white px-4 py-2">Más Popular</span>
                            </div>
                            <h3 className="card-title text-dark mb-2">Plan Premium</h3>
                            <p className="text-dark-emphasis small mb-3">La opción más popular para resultados serios</p>
                            {/* <div class="d-flex align-items-center justify-content-center position-relative">
                                <div class="d-flex flex-column">
                                    <span class="badge bg-danger align-self-start mb-1">-34%</span>
                                    <span class="text-danger text-decoration-line-through me-2" style={{fontSize: "1.2rem;"}}>€500€</span>
                                </div>
                                <div class="d-flex align-items-baseline">
                                    <span class="display-4 fw-bold text-dark">950€</span>
                                    <span class="text-dark-emphasis">/año</span>
                                </div>
                            </div> */}
                            <div class="d-flex align-items-baseline justify-content-center">
                                <span class="display-4 fw-bold text-dark">950€</span>
                                <span class="text-dark-emphasis">/año</span>
                            </div>
                        </div>

                        <div className="card-body position-relative">
                            <div className="feature-category mb-3">
                                <button className="btn btn-link text-start w-100 p-0 text-dark fw-semibold small d-flex align-items-center justify-content-between" 
                                        onClick={()=>{setupCollapseListeners()}} data-bs-toggle="collapse" data-bs-target="#access">
                                    Acceso y Visibilidad
                                    <i class="bi bi-chevron-right transition-icon"></i>
                                </button>
                                <div className="collapse" id="access">
                                    <div className="mt-2">
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Mayor número de publicaciones de servicios</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Perfil mejorado (galería, más datos)</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Mayor visibilidad en búsquedas</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Video presentación comunidad Cuidatia</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Verificación VIP</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Historia de vida de usuarios</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="feature-category mb-3">
                                <button className="btn btn-link text-start w-100 p-0 text-dark fw-semibold small d-flex align-items-center justify-content-between" 
                                        onClick={()=>{setupCollapseListeners()}} data-bs-toggle="collapse" data-bs-target="#marketing">
                                    Marketing y Promoción
                                    <i class="bi bi-chevron-right transition-icon"></i>
                                </button>
                                <div className="collapse" id="marketing">
                                    <div className="mt-2">
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Bienvenida RRSS y Newsletter</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Acceso a campañas promocionales internas</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Patrocinio Webinar X% descuento</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Herramientas de marketing</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Rendimiento de campañas personalizado</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-category mb-3">
                                <button className="btn btn-link text-start w-100 p-0 text-dark fw-semibold small d-flex align-items-center justify-content-between" 
                                        onClick={()=>{setupCollapseListeners()}} data-bs-toggle="collapse" data-bs-target="#support">
                                    Gestión y Soporte Profesional
                                    <i class="bi bi-chevron-right transition-icon"></i>
                                </button>
                                <div className="collapse" id="support">
                                    <div className="mt-2">
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Soporte prioritario (chat horario laboral)</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Análisis detallado (tendencias y comparativas)</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Feedback del cliente</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Tarjeta digital y Agenda digital</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Facturación electrónica</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-category mb-4">
                                <button className="btn btn-link text-start w-100 p-0 text-dark fw-semibold small d-flex align-items-center justify-content-between" 
                                        onClick={()=>{setupCollapseListeners()}} data-bs-toggle="collapse" data-bs-target="#recursos">
                                    Desarrollo y Recursos Exclusivos
                                    <i class="bi bi-chevron-right transition-icon"></i>
                                </button>
                                <div className="collapse" id="recursos">
                                    <div className="mt-2">
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Eventos presenciales 40% de descuento</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Formación digital</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Aplicaciones para usuarios Físico/Cognitivo</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-x-circle-fill text-danger me-2"></i>
                                            <span className="text-dark-emphasis small">Creación libros digitales/físicos con X% descuento</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button className="btn btn-primary w-100 cta-button premium-cta" onClick={()=>{handlePurchase('premium')}}>
                                <span>Comenzar Ahora</span>
                                <i class="bi bi-arrow-right transition-icon ms-2"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4 col-md-6">
                    <div className="card membership-card h-100" data-plan="todo">
                        <div className="card-gradient todo-gradient"></div>
                        <div className="glass-effect"></div>
                        
                        <div className="card-header text-center border-0 bg-transparent position-relative">
                            {/* <div className="plan-icon todo-icon mx-auto mb-3">
                                <i className="bi bi-2-circle-fill"></i>
                            </div> */}
                            <div className="popular-badge mb-3 mx-auto">
                                <span className="badge bg-gradient-yellow text-white px-4 py-2">Mejor Valorado</span>
                            </div>
                            <h3 className="card-title text-dark mb-2">Plan Todo Incluido</h3>
                            <p className="text-dark-emphasis small mb-3">La experiencia definitiva para empresas</p>
                            {/* <div class="d-flex align-items-center justify-content-center position-relative">
                                <div class="d-flex flex-column">
                                    <span class="badge bg-danger align-self-start mb-1">-50%</span>
                                    <span class="text-danger text-decoration-line-through me-2" style={{fontSize: "1.2rem;"}}>4000€</span>
                                </div>
                                <div class="d-flex align-items-baseline">
                                    <span class="display-4 fw-bold text-dark">2000€</span>
                                    <span class="text-dark-emphasis">/año</span>
                                </div>
                            </div> */}
                            <div class="d-flex align-items-baseline justify-content-center">
                                <span class="display-4 fw-bold text-dark">2000€</span>
                                <span class="text-dark-emphasis">/año</span>
                            </div>
                        </div>

                        <div className="card-body position-relative">
                            <div className="feature-category mb-3">
                                <button className="btn btn-link text-start w-100 p-0 text-dark fw-semibold small d-flex align-items-center justify-content-between" 
                                        onClick={()=>{setupCollapseListeners()}} data-bs-toggle="collapse" data-bs-target="#access">
                                    Acceso y Visibilidad
                                    <i class="bi bi-chevron-right transition-icon"></i>
                                </button>
                                <div className="collapse" id="access">
                                    <div className="mt-2">
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Publicaciones ilimitadas de servicios</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Perfil completo (videos, testimonios, redes sociales)</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Visibilidad máxima en búsquedas</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Video presentación comunidad Cuidatia</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Verificación VIP</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Historia de vida de usuarios</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-category mb-3">
                                <button className="btn btn-link text-start w-100 p-0 text-dark fw-semibold small d-flex align-items-center justify-content-between" 
                                        onClick={()=>{setupCollapseListeners()}} data-bs-toggle="collapse" data-bs-target="#marketing">
                                    Marketing y Promoción
                                    <i class="bi bi-chevron-right transition-icon"></i>
                                </button>
                                <div className="collapse" id="marketing">
                                    <div className="mt-2">
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Bienvenida RRSS y Newsletter</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Acceso exclusivo a campañas especiales</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Patrocinio Webinar X% descuento</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Herramientas de marketing</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Rendimiento de campañas personalizado</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-category mb-3">
                                <button className="btn btn-link text-start w-100 p-0 text-dark fw-semibold small d-flex align-items-center justify-content-between" 
                                        onClick={()=>{setupCollapseListeners()}} data-bs-toggle="collapse" data-bs-target="#support">
                                    Gestión y Soporte Profesional
                                    <i class="bi bi-chevron-right transition-icon"></i>
                                </button>
                                <div className="collapse" id="support">
                                    <div className="mt-2">
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Soporte personalizado 24/7</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Análisis avanzado (demografía, ROI)</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Acceso a programas de fidelización</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Tarjeta digital y Agenda digital</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Facturación electrónica</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="feature-category mb-4">
                                <button className="btn btn-link text-start w-100 p-0 text-dark fw-semibold small d-flex align-items-center justify-content-between" 
                                        onClick={()=>{setupCollapseListeners()}} data-bs-toggle="collapse" data-bs-target="#recursos">
                                    Desarrollo y Recursos Exclusivos
                                    <i class="bi bi-chevron-right transition-icon"></i>
                                </button>
                                <div className="collapse" id="recursos">
                                    <div className="mt-2">
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Eventos presenciales incluidos</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Formación digital</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Aplicaciones para usuarios Físico/Cognitivo</span>
                                        </div>
                                        <div className="feature-item">
                                            <i className="bi bi-check-circle-fill text-success me-2"></i>
                                            <span className="text-dark-emphasis small">Creación libros digitales/físicos con X% descuento</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <button className="btn btn-primary w-100 cta-button elite-cta" onClick={()=>{handlePurchase('todo')}}>
                                <span>Comenzar Ahora</span>
                                <i class="bi bi-arrow-right transition-icon ms-2"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="text-center mt-5">
                <div className="d-inline-flex align-items-center gap-3 glass-badge rounded-pill px-4 py-3">
                    <span className="text-dark-emphasis small">¿Necesitas ayuda para decidir?</span>
                    <button className="btn btn-sm btn-outline-dark" onClick={() => {navigate('/soporte')}}>
                        Contacta con nosotros
                    </button>
                </div>
            </div>

            {/* <div className="row g-4 mt-5 justify-content-center">
                <div className="col-6 col-md-3 text-center">
                    <div className="display-5 fw-bold text-dark-emphasis mb-2">500+</div>
                    <div className="text-dark-emphasis small">Miembros Activos</div>
                </div>
                <div className="col-6 col-md-3 text-center">
                    <div className="display-5 fw-bold text-dark-emphasis mb-2">24/7</div>
                    <div className="text-dark-emphasis small">Acceso Disponible</div>
                </div>
                <div className="col-6 col-md-3 text-center">
                    <div className="display-5 fw-bold text-dark-emphasis mb-2">50+</div>
                    <div className="text-dark-emphasis small">Clases Semanales</div>
                </div>
                <div className="col-6 col-md-3 text-center">
                    <div className="display-5 fw-bold text-dark-emphasis mb-2">5★</div>
                    <div className="text-dark-emphasis small">Calificación Promedio</div>
                </div>
            </div> */}
        </div>
    </div>

    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
    </body>
    </>
    );
}